import React, { useEffect, useState } from "react";
import axios from "axios";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Button from "components/CustomButtons/Button.js";
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-kit-pro-react/views/ecommerceSections/latestOffersStyle.js";

import trendyolLogo from "assets/img/logos/trendyol.png";
import hepsiburadaLogo from "assets/img/logos/hepsiburada.png";
import { Link } from "react-router-dom";

const useStyles = makeStyles(styles);

export default function SectionLatestOffers() {
  const classes = useStyles();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    
axios.get("https://ecommerce24.pythonanywhere.com/api/products/?is_featured=true")
      .then((res) => setProducts(res.data.slice(0, 3))) // En fazla 3 ürün
      .catch((err) => console.error("Öne çıkan ürünler alınamadı:", err));
  }, []);

  return (
    <div className={classes.section}>
      <div className={classes.container}>
        <h2>ÖNE ÇIKANLAR</h2>
        <GridContainer>
          {products.map((item, index) => (
            <GridItem md={4} sm={6} xs={12} key={index}>
              <Card product plain>
                <CardHeader image plain>
                  <Link to={`/products/${item.slug}`}>
  <img src={`https://ecommerce24.pythonanywhere.com${item.cover_image}`} alt={item.name} style={{ width: "100%", objectFit: "cover", aspectRatio: "1/1" }} />
</Link>

                  <div
                    className={classes.coloredShadow}
                    style={{
                      backgroundImage: `url(https://ecommerce24.pythonanywhere.com${item.cover_image})`,
                      opacity: 1,
                    }}
                  />
                </CardHeader>
                <CardBody className={classes.textCenter} plain>
                  <h4 className={classes.cardTitle}>{item.name}</h4>
                  <p
  className={classes.cardDescription}
  style={{ whiteSpace: "pre-line" }}
>
  {item.description
    ? item.description.split(/(?<=[.?!])\s+/).slice(0, 2).join(" ")
    : "Açıklama bulunamadı."}
</p>


                </CardBody>
                <CardFooter plain style={{ justifyContent: "center", gap: "1rem" }}>
                  {item.trendyol_url && (
                    <Button justIcon target="_blank" href={item.trendyol_url} color="white">
                      <img src={trendyolLogo} alt="Trendyol" style={{ height: 30 }} />
                    </Button>
                  )}
                  {item.hepsiburada_url && (
                    <Button justIcon target="_blank" href={item.hepsiburada_url} color="white">
                      <img src={hepsiburadaLogo} alt="Hepsiburada" style={{ height: 30 }} />
                    </Button>
                  )}
                </CardFooter>
              </Card>
            </GridItem>
          ))}
        </GridContainer>
      </div>
    </div>
  );
}
